<template>
  <div>
    <b-row>
      <b-col
        v-if="showCustomer"
        cols="12"
        xl="4"
      >
        <CustomerWithCreate
          :formName="formName"
          :disabled="disabled"
          v-model="dados.tomador"
        />
      </b-col>
      <b-col :sm="showCustomer ? '4' : '12'">
        <Select
          title="Serviço"
          field="type"
          :formName="formName"
          :required="true"
          :disabled="disabled"
          url="/api/v1/tax-document/taxation/select-all"
          v-model="dados.servico"
          :showNewRegister="false"
        >
        </Select>
      </b-col>
      <b-col
        v-if="showLocacao"
        cols="12"
        xl="4"
      >
        <Select
          title="Locação Vinculada"
          field="type"
          :formName="formName"
          :required="false"
          url="api/v1/rental/rent/select-all"
          v-model="dados.locacao"
          :showNewRegister="false"
        >
        </Select>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12" sm="10">
        <TextArea
          title="Descrição"
          field="description"
          :disabled="disabled"
          :required="true"
          v-model="dados.descricao"
          :maxLength="1000"
        />
      </b-col>
      <b-col cols="12" sm="2">
        <div class="div-import-model">
          <Button
            _key="btnImportModeloNfseNacional"
            title="Impor...Padrão"
            type="info"
            size="small"
            class="btn-import-model-fixed"
            classIcon="fa-solid fa-file-import"
            :disabled="disabled || !dados.servico || !dados.servico.id"
            :clicked="getParameter"
          />
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col
        v-if="showValor"
        cols="12"
        lg="2"
      >
        <InputDecimal
          title="Valor do Serviço"
          field="valor"
          type="float"
          :formName="formName"
          :required="false"
          :maxLength="9"
          :disabled="disabled"
          v-model="dados.valorNota"
        />
      </b-col>
    </b-row>
    <!--  <b-row>
            <b-col sm="12">
                <InputTagEmail v-model="dados.emails" :customerId="dados.tomador.id" />
            </b-col>
        </b-row> -->
  </div>
</template>

<script>
import Button from "@nixweb/nixloc-ui/src/component/forms/Button";
import InputDecimal from "@nixweb/nixloc-ui/src/component/forms/InputDecimal";
import Select from "@nixweb/nixloc-ui/src/component/forms/Select";
import TextArea from "@nixweb/nixloc-ui/src/component/forms/TextArea";

import CustomerWithCreate from "../../rental/shared/CustomerWithCreate.vue";
import InputTagEmail from "../notification/InputTagEmail.vue";

import NfseNacional from "./NfseNacional.js";

import { mapActions, mapMutations } from "vuex";

export default {
  name: "Dados",
  props: {
    formName: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Object,
      default: () => ({}),
    },
    showCustomer: {
      type: Boolean,
      default: true,
    },
    showLocacao: {
      type: Boolean,
      default: true,
    },
    showValor: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    InputTagEmail,
    InputDecimal,
    Button,
    Select,
    TextArea,
    CustomerWithCreate,
  },
  data() {
    return {
      dados: new NfseNacional().dados,
      urlGetParameter: "/api/v1/tax-document/taxation/get-parameter",
    };
  },
  methods: {
    ...mapActions("generic", ["postApi"]),
    ...mapMutations("generic", ["removeLoading"]),
    getParameter() {
      const servicoId = this.dados?.servico?.id;
      if (!servicoId) return;

      const locacaoId = this.dados?.locacao?.id || this.$route?.params?.rentId;
      const obj = { servicoId };
      if (locacaoId) obj.locacaoId = locacaoId;

      const params = {
        url: this.urlGetParameter,
        obj,
        notNotifyToast: true,
      };

      this.postApi(params)
        .then((response) => {
          this.dados.descricao = response?.content || "";
        })
        .finally(() => {
          this.removeLoading(["btnImportModeloNfseNacional"]);
        });
    },
  },
  watch: {
    value: {
      deep: true,
      handler(value) {
        if (value.id) this.dados = value;
      },
    },
    dados: {
      deep: true,
      handler(newVal) {
        this.$emit("input", newVal);
      },
    },
  },
};
</script>

<style scoped>
.div-import-model {
  margin-top: 26px;
  width: 170px;
  min-width: 170px;
}

.btn-import-model-fixed {
  width: 170px;
}
</style>
